// bg.dependencies.js
import InfoBox from "./lib/infobox.js";
import LazyLoad from "./lib/lazyload.min.js";
import NoSleep from "nosleep.js";
import * as FFlate from "fflate";
// set window globals
window.InfoBox = InfoBox;
window.LazyLoad = LazyLoad;
window.NoSleep = NoSleep;
window.FFlate = FFlate;

import "./lib/clarker/clarker.js";
import "./lib/intersection-observer.js";
// bg.denied.compiled.js
import "./batchgeo-access-view/batchgeo-access-view.js";
// batchgeo.js
import "./batchgeo-google-maps-manager/batchgeo-google-maps-pane-finder.js";
import "./xss-safe-worker/xss-safe-worker.js";
import "./batchgeo-euro-date-converter/batchgeo-euro-date-converter.js";
import "./batchgeo-generator/batchgeo-generator-reducer.js";
import "./batchgeo-ui/batchgeo-ui.js";
import "./batchgeo-ui/batchgeo-ui-login-form.js";
import "./batchgeo-ui/batchgeo-ui-mobile-data-view-button.js";
import "./batchgeo-ui/batchgeo-ui-map-mode-toggle.js";
import "./batchgeo-captcha/batchgeo-captcha.js";
import "./batchgeo-tableize/batchgeo-tableize.js";
import "./batchgeo-autocomplete/batchgeo-autocomplete.js";
import "./batchgeo-omnibox/batchgeo-omnibox-clear-search-button.js";
import "./batchgeo-omnibox/batchgeo-omnibox.js";
import "./batchgeo-svg-marker-icon/batchgeo-svg-marker-icon.js";
import "./batchgeo-toolbar/batchgeo-toolbar.js";
import "./batchgeo-toolbar/batchgeo-toolbar-tooltip-reducer.js";
import "./batchgeo-base-toolbar/batchgeo-base-toolbar.js";
import "./batchgeo-optimal-route-toolbar/batchgeo-calculate-route.js";
import "./batchgeo-optimal-route-toolbar/batchgeo-optimal-route-toolbar.js";
import "./batchgeo-optimal-route-toolbar/batchgeo-optimal-route-toolbar-reducer.js";
import "./batchgeo-optimal-route-toolbar/batchgeo-group-distance.js";
import "./batchgeo-optimal-route-toolbar/batchgeo-kdtree.js";
import "./batchgeo-optimal-route-toolbar/batchgeo-munkres.js";
import "./batchgeo-clarker-overlay/batchgeo-clarker-overlay.js";
import "./batchgeo-user-location/batchgeo-user-location-reducer.js";
import "./batchgeo-user-location/batchgeo-user-location.js";
import "./batchgeo-printer/batchgeo-printer-reducer.js";
import "./batchgeo-printer/batchgeo-printer-choices.js";
import "./batchgeo-printer/batchgeo-print-table-templates.js";
import "./batchgeo-printer/batchgeo-printer-progressbar.js";
import "./batchgeo-printer/batchgeo-printer-dialog.js";
import "./batchgeo-printer/batchgeo-print-table.js";
import "./batchgeo-printer/batchgeo-printer.js";
import "./batchgeo-map-context-menu/batchgeo-map-context-menu.js";
import "./batchgeo-table/batchgeo-table-context-menu.js";
import "./batchgeo-cluster/batchgeo-cluster-reducer.js";
import "./batchgeo-cluster/batchgeo-cluster.js";
import "./batchgeo-heatmap/batchgeo-heatmap-reducer.js";
import "./batchgeo-heatmap/batchgeo-heatmap.js";
import "./batchgeo-contact-owner/batchgeo-contact-owner.js";
import "./batchgeo-context-menu/batchgeo-context-menu.js";
import "./batchgeo-context-menu/batchgeo-context-menu-reducer.js";
import "./batchgeo-map/batchgeo-map-scale-bar-default-unit.js";
import "./batchgeo-google-maps-manager/batchgeo-marker-legend-reducer.js";
import "./batchgeo-custom-extents/batchgeo-custom-extents-reducer.js";
import "./batchgeo-custom-extents/batchgeo-custom-extents.js";
import "./batchgeo-store-locator/batchgeo-store-locator-reducer.js";
import "./batchgeo-store-locator/batchgeo-store-locator-no-results-view.js";
import "./batchgeo-store-locator/batchgeo-store-locator-marker-thumbnail.js";
import "./batchgeo-store-locator/batchgeo-store-locator-marker-label.js";
import "./batchgeo-store-locator/batchgeo-store-locator-list-item.js";
import "./batchgeo-store-locator/batchgeo-store-locator-search.js";
import "./batchgeo-store-locator/batchgeo-store-locator.js";
import "./batchgeo-vertical-resizer/batchgeo-vertical-resizer.js";
import "./batchgeo-data-and-table-resizer/batchgeo-data-and-table-resizer.js";
import "./batchgeo-map/batchgeo-map.js";
import "./bg.map.js";
// bg.generator.compiled.js
import "./bg.generator.js";
import "./batchgeo-geocoder/batchgeo-geocoder.js";
// bg.modules.js
import "./batchgeo-google-maps-manager/batchgeo-duplicate-marker-label-overlay.js";
import "./batchgeo-email-service/batchgeo-email-service.js";
import "./batchgeo-table/batchgeo-table-map-reducer.js";
import "./batchgeo-google-maps-manager/batchgeo-google-markers-reducer.js";
import "./batchgeo-drawing-manager/batchgeo-drawing-manager-reducer.js";
import "./batchgeo-marker-measure/batchgeo-marker-measure-reducer.js";
import "./batchgeo-table/row-select-reducer.js";
import "./batchgeo-table/header-sort-reducer.js";
import "./batchgeo-google-maps-manager/batchgeo-marker-drawer-reducer.js";
import "./batchgeo-google-maps-manager/batchgeo-google-maps-manager-reducer.js";
import "./batchgeo-google-maps-manager/batchgeo-google-maps-markers.js";
import "./batchgeo-google-maps-manager/batchgeo-marker-groups.js";
import "./batchgeo-map-tooltip/batchgeo-map-tooltip.js";
import "./batchgeo-marker-tooltip/batchgeo-marker-tooltip.js";
import "./batchgeo-google-maps-manager/batchgeo-marker-drawer.js";
import "./batchgeo-infowindow/batchgeo-infowindow-generate-directions-url.js";
import "./batchgeo-infowindow/batchgeo-infowindow-page.js";
import "./batchgeo-infowindow/batchgeo-infowindow-create-address.js";
import "./batchgeo-infowindow/batchgeo-infowindow-page-events.js";
import "./batchgeo-google-maps-manager/batchgeo-marker-content.js";
import "./batchgeo-google-maps-manager/batchgeo-marker-legend.js";
import "./batchgeo-google-maps-manager/batchgeo-marker-resizer.js";
import "./batchgeo-mobile-infowindow/batchgeo-mobile-infowindow-reducer.js";
import "./batchgeo-mobile-infowindow/batchgeo-mobile-infowindow.js";
import "./batchgeo-google-maps-manager/batchgeo-marker-infowindow.js";
import "./batchgeo-google-maps-manager/batchgeo-google-maps-manager.js";
// bg.advanced.compiled.js
import "./batchgeo-marker-measure/batchgeo-marker-measure-polylines.js";
import "./batchgeo-marker-measure/batchgeo-marker-measure-marker-overlay.js";
import "./batchgeo-marker-measure/batchgeo-marker-measure-marker.js";
import "./batchgeo-marker-measure/batchgeo-marker-measure.js";
import "./batchgeo-drawing-manager/batchgeo-drawing-manager-basetool.js";
import "./batchgeo-drawing-manager/batchgeo-drawing-manager-hand.js";
import "./batchgeo-drawing-manager/batchgeo-drawing-manager-rectangle.js";
import "./batchgeo-drawing-manager/batchgeo-drawing-manager-circle.js";
import "./batchgeo-drawing-manager/batchgeo-drawing-manager-polygon.js";
import "./batchgeo-drawing-manager/batchgeo-drawing-manager-ruler.js";
import "./batchgeo-drawing-manager/batchgeo-drawing-manager.js";
import "./batchgeo-keyboard-shortcuts/keyboard-shortcuts.js";
import "./batchgeo-keyboard-shortcuts/batchgeo-keyboard-shortcuts.js";
// bg.batchgeotablemap.compiled.js
import "./batchgeo-copy-machine/batchgeo-copy-machine.js";
import "./batchgeo-table/table-exporter.js";
import "./batchgeo-table/batchgeo-table.js";
import "./batchgeo-table/distance-column-generator.js";
import "./batchgeo-table/destination-column-generator.js";
import "./batchgeo-table/optimal-distance-column-generator.js";
import "./batchgeo-table/marker-label-column-generator.js";
import "./batchgeo-table/header-sort.js";
import "./batchgeo-table/row-linkifier.js";
import "./batchgeo-table/row-select.js";
import "./batchgeo-table/row-filter.js";
import "./batchgeo-table/batchgeo-table-map.js";
import "./batchgeo-survey/batchgeo-survey.js";
